/** Shared by the hosted tag and the backwards-compatible, early CMP helper.
 * Installing the function never reads a CMP/storage or grants consent.
 */
export function browserConsentBridgeSource(policyVersion) {
    return `window.moonshotConsentChanged = function (choice) {
  choice = choice || {};
  var source = typeof choice.cmpSource === "string" ? choice.cmpSource.trim() : "";
  var purposes = Array.isArray(choice.purposes) ? choice.purposes.slice() : [];
  var accepted = choice.status === "accepted" && source && source !== "EXISTING_CMP"
    && purposes.includes("visitor_identification") && purposes.includes("journey")
    && typeof choice.expiresAt === "string" && Date.parse(choice.expiresAt) > Date.now();
  var method = accepted ? "activate" : "withdraw";
  var argument = accepted ? {
    status: "accepted", purposes: purposes, cmpSource: source,
    policyVersion: ${JSON.stringify(policyVersion).replaceAll("<", "\\u003c")}, expiresAt: choice.expiresAt
  } : (source || "cmp-choice-unavailable");
  if (typeof window.MoonshotConsent?.[method] === "function") return window.MoonshotConsent[method](argument);
  (window.MoonshotConsentQueue = window.MoonshotConsentQueue || []).push([method, argument]);
};`;
}
//# sourceMappingURL=browser-consent-bridge.js.map